module.exports = __webpack_public_path__ + "img/uebungsdienst.16a12f1a.jpg";